import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as FullscreenActions from './fullscreen.actions';
import * as FullscreenSelectors from './fullscreen.selectors';

import { Observable } from 'rxjs';

@Injectable()
export class FullscreenFacade {
  constructor(private readonly store: Store) {}

  public getFullscreenState(): Observable<boolean> {
    return this.store.pipe(select(FullscreenSelectors.getFullscreenState()));
  }

  public setFullscreenState(fullscreenState: boolean): void {
    this.store.dispatch(FullscreenActions.setFullscreenState({ fullscreenState }));
  }
}
